"use client";

import React from 'react';
import Image from 'next/image';
import { Link } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';

const Footer = () => {
  const t = useTranslations('common');
  const currentYear = new Date().getFullYear();

  const footerData = {
    links: [
      { text: t('navigation.myOrders'), href: "/my-orders", showMobile: true },
      { text: t('navigation.aboutUs'), href: "/about-us", showMobile: true },
      { text: t('navigation.contactUs'), href: "/contact-us", showMobile: true }
    ],
    footerLinks: [
      { text: t('footer.termsAndConditions'), href: "/terms" },
      { text: t('footer.privacyPolicy'), href: "/privacy" },
      { text: t('footer.californiaPrivacy'), href: "/california-privacy" },
      { text: t('footer.returnPolicy'), href: "/returns" }
    ]
  };
  return footerData ? (
    <footer className="bg-[#454646] text-white px-4 md:py-5 pb-3">
      <div className="max-w-[930px] mx-auto flex flex-col justify-between">
        {/* Navigation Links */}
        <div className="flex gap-x-16">
          <div className="flex flex-col items-center mt-4 space-y-4">
            <ul className="space-y-2">
              {Array.isArray(footerData.links) && footerData.links.map((link, index) => (
                <React.Fragment key={index}>
                  <li className="">
                    <Link href={link.href} className="">
                      {link.text}
                    </Link>
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </div>
          <div className="flex flex-col items-center mt-4 space-y-4">
            <ul className="space-y-2">
              {Array.isArray(footerData.footerLinks) && footerData.footerLinks.map((link, index) => (
                <React.Fragment key={index}>
                  <li>
                    <Link href={link.href} className="">
                      {link.text}
                    </Link>
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-6 md:mt-12">
          <div className="text-[14px] leading-[18px] text-white">
            <div className="font-semibold">{t('footer.company')}</div>
            <div className="">{t('footer.address')}</div>
          </div>
          <div className="mt-4 flex justify-center md:hidden">
            <Link
              href="/"
              className="brand-logo w-[110px] border-b border-white"
            >
              <Image
                src="/images/main-logo.svg"
                width={109}
                height={37}
                alt="Book Tailor Logo"
              />
            </Link>
          </div>
        </div>
        {/* Divider */}
        <div className="flex items-center mt-[10px] md:mt-5">
          <div className="w-full border-t border-[#888888] flex-1"></div>
          <span className="text-sm md:text-base w-fit px-2">© {t('footer.copyright', { year: currentYear })}</span>
          <div className="w-full border-t border-[#888888] flex-1"></div>
        </div>

        {/* Footer Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-end w-full mt-1">
          <div className="mt-4 md:mt-0 hidden md:block">
            <Link
              href="/"
              className="brand-logo h-[40px] md:h-[67px] w-[97px] md:w-[312px] border-b"
            >
              <Image
                src="/images/main-logo.svg"
                width={109}
                height={37}
                alt="Book Tailor Logo"
              />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  ) : null;
};

export default Footer;